module.exports = __webpack_public_path__ + "static/img/D4105.5a227a84.png";